import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RichTextEditorComponent } from './rich-text-editor.component';
import { NgxEditorModule } from 'ngx-editor';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
  exports: [
    CommonModule,
    RichTextEditorComponent
  ],
  declarations: [
    RichTextEditorComponent
  ],
  imports: [
    CommonModule,
    NgxEditorModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class RichTextEditorModule { }
